/**
 * @owner @Appboy/frontend-ix
 */
import { QueryClient } from "@tanstack/react-query";

/**
 * This is the cache controller for react-query. It can be used to flush or prime the cache in any environment
 *
 * It is also used in the top-level provider for the react binding defined in app/javascript/src/lib/reactApp.tsx
 *
 * @example
 * import { queryClient } from "@lib/queryClient";
 * queryClient.invalidateCache("canvasDigest");
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
    },
  },
});

export * from "./runOperatorQuery";
